
import Icon from "../../../../public/assets/images/keinternational/true.png"
import { FaPlus } from "react-icons/fa6";
import { FiMinus } from "react-icons/fi";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";



const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });




export const SectionEleven = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className="section-eleven-Ind">
      <div className="container-fluid">



        <div className="quote1">
          <img src="assets/images/keindia/quote.png" alt="" />
          <h4 className="quotes1">What used to be a manual, hit-or-miss process is now a scalable,<br /> high-performance engine — all thanks to KwikPass and KwikEngage.</h4>

          <p className="owner">Surender Singh, EIR SAADAA</p>

          <img style={{ marginTop: "15px" }} src="assets/images/keindia/saada.png" alt="" />
        </div>
        <hr style={{ color: '#827A6E', margin: '40px 0' }} />


        <div className="testimonial-content">
          <div className="testimonial-text1">Ready to see <br />KwikEngage in Action?</div>

          <div onClick={scrollToTop} className="cta1a-Ind">Book a Demo</div>
        </div>

      </div>

    </div>



  )
};
